import { ReferenceInput, SelectInput, required } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { CreditsInput, GridItem, InstructionLanguageInput, NationalityInput } from "./Partials";

const StateExamFields = () => (
  <>
    <GridItem md={12}>
      <ReferenceInput
        source="stateExamId"
        reference={administrationRequests.getStateExamsSelect()}
      >
        <SelectInput
          optionText="name"
          label="Държавен изпит"
          fullWidth
          validate={required("Полето е задължително.")}
        />
      </ReferenceInput>
    </GridItem>

    <NationalityInput />
    <InstructionLanguageInput />
    <CreditsInput md={12} />
  </>
);

export default StateExamFields;
